import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Checkbox } from 'primereact/checkbox';
import * as XLSX from "xlsx";        
import CourseCombo from '../combos/CourseCombo';
import FaDate from '../shared/FaDate';
import ScoreSave from './ScoreSave'
import EduMonthCombo from '../combos/EduMonthCombo';
import TeacherSchoolClassCourseCombo from '../combos/TeacherSchoolClassCourseCombo';
import { Col, Form, Row } from 'react-bootstrap';

export default function TeacherExams(props) {
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [scoreTargetType, setScoreTargetType] = useState(util.scoreTypes.ContinualTest);
  const [schoolClassDegree, setSchoolClassDegree] = useState(-1);
  const [scoreTargetId, setScoreTargetId] = useState("");
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [newFormVisible, setNewFormVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

  
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const LoadingRows = Array.from({length:5});

  const [currentId, setCurrentId] = useState("");
  const [date, setDate] = useState(0);
  const [newDate, setNewDate] = useState(0);
  const [schoolCalss, setSchoolclass] = useState(null);
  const [course, setCourse] = useState(null);
  const [comment, setComment] = useState("");
  const [month, setMonth] = useState(null);
  const [students, setStudents] = useState([]);
  const [searchSchoolClass, setSearchSchoolClass] = useState(null);
  const [searchCourse, setSearchCourse] = useState(null);
  const [searchMonth, setSearchMonth] = useState(null);
  
  useEffect(() => {

    searchExams();
  }, []);
  const searchExams = function(){
    console.log("device type is>", util.isMobile());
    setLoading(true);
    var sSchoolClassId = "";
    if(searchSchoolClass != null){
      if(searchSchoolClass.id != null){
        sSchoolClassId = searchSchoolClass.id;
      }
    }
    var sCourseId = "";
    if(searchCourse != null){
      if(searchCourse.id != null){
        sCourseId = searchCourse.id;
      }
    }
    var monthInd = 0;
    if(searchMonth != null){
      if(searchMonth.code != null){
        monthInd = parseInt(searchMonth.code);
      }
    }

    var params = {login:util.getTrustedUser(), lastIndex:0, pageSize:0, continualTestId:"", schoolClassId:sSchoolClassId, courseId:sCourseId, monthInd:monthInd};
    var url = config.Server+`/school/teacher/continual-test/list`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("response is>", response);
                
                setItems(response);
                setFilterItems(response);
                
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });
  }
  const addNewItem = function(){
    setDate(0);
    setMonth(null);
    setSchoolclass(null);
    setCourse(null);
    setComment("کتبی");
    setNewFormVisible(true);
  }
  const onRowEditClick = function(row) {
    if(row.isFinal){
      setErrorMessage("نمرات نهائی در این بخش قابل ویرایش نیستند");
      setErorVisible(true);
      return;
    }
    setSchoolClassDegree(row.schoolClass.degree);
    setScoreTargetId(row.id);
    setEditFormVisible(true);        
  }
  const onRowDeleteClick = function(row) {
    setCurrentId(row.id);
    setConfirmDeleteVisible(true);
  }

  const closeNewDialog = function(){
    setNewFormVisible(false);
  }
  const closeEditDialog = function(){
    setEditFormVisible(false);
  }
  const deleteItem = function(){
    setDeleting(true);
    var id = currentId;
    var params = {login:util.getTrustedUser(), id:currentId};
    var url = config.Server+`/school/teacher/continual-test/delete`;
      axios
          .post(url, params )
          .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var tmp = [...items];
                for(var i=0;i<tmp.length;i++){
                  if(tmp[i].id === id){
                    tmp.splice(i, 1);
                    break;
                  }
                }
                setCurrentId("");
                setItems(tmp);
                setFilterItems(tmp);

                setDeleting(false);
                setConfirmDeleteVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
          })
          .catch(error => {
            setDeleting(false);
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
          });
  }
  const onDeleteConfirm_Accept = function(){
    deleteItem();
  }
  const onDeleteConfirm_Reject = function(){
      if(deleting) return;
      setConfirmDeleteVisible(false);
  }

  const checkDataEntry = function(){
      return true;
  }
  const saveItem = function(){
    if(!checkDataEntry()) return;

  }
  const checkDataEntryNew = function(){
    if(newDate<=0){
      setErorVisible(true);
      setErrorMessage("تاریخ آزمون را مشخص نمائید");
      return false;
    }
    if((schoolCalss == null)||(course == null)){
      setErorVisible(true);
      setErrorMessage("کلاس-درس را مشخص نمائید");
      return false;

    }
    if((comment == null)||(comment == "")){
      setErorVisible(true);
      setErrorMessage("شرح نمره(کتبی، شفاهی یا عملی) را مشخص نمائید");
      return false;    
    }
    if((month == null)||(month == {})||(month == "")||(month <= 0)){
      setErorVisible(true);
      setErrorMessage("کارنامه ماهیانه را مشخص نمائید");
      return false;
    }
    return true;
  }
  const saveNewItem = function(){
    if(!checkDataEntryNew()) return;
      setSaving(true);
      var params = {login:util.getTrustedUser(), id:"", courseId:course.id, schoolClassId:schoolCalss.id, testDate:newDate, monthInd:month, comment:comment, isFinal:false, isAgent:false, students:[]};
      var url = config.Server+`/school/teacher/continual-test/save`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  setCurrentId(response.id);
                  var tmp = [...items];
                  tmp.push(response);
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setSaving(false);
                  setNewFormVisible(false);
                  setSchoolClassDegree(schoolCalss.degree);
                  setScoreTargetId(response.id);
                  setEditFormVisible(true);        

              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

  }
  const editDialogFooter = function(){
      return (
          <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{closeEditDialog()}} saving={saving} />
      )
  }
  const newDialogFooter = function(){
      return (
          <GeneralDialogFooter onOkClick={()=>{saveNewItem()}} onCancelClick={()=>{closeNewDialog()}} saving={saving} />
      )
  }
  const onInputChange = function(e, name){
      var val = '';
      val = (e.target && e.target.value) || '';
      if(name === "comment") setComment(val);
//      else if(name === "firstname") setFirstname(val);
  }

  const onComboChange = function(name, value){
    if(name === "searchMonth"){
      setMonth(value);
    }
    else if(name === "searchSchoolClass"){
      setSearchSchoolClass(value);
    }
    else if(name === "searchCourse"){
      setSearchCourse(value);
    }
    return
  }
  const setRowActions = function(row) {
      return (
            <Row className="justify-content-md-center" style={{}}>
              <Button icon="pi pi-pencil" rounded severity="success" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
              <Button icon="pi pi-trash" rounded severity="danger" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
            </Row>
      );
  }
  const onContinualTestChanged = function (targetType, targetId){
    var tmp = [...filterItems];
    for(var i=0;i<tmp.length;i++){
      var state = tmp[i];
      if(state.id == targetId){
      }
    }

    setFilterItems(tmp);
  }
  return(      
    <>   
      <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>لیست نمرات آزمون ها</div>
      <div className="" style={{ width:"calc(100% - 0px)"}}>
        <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
            <Row>
              <Col md={3}>
                <CourseCombo returnFullItem={true} value={searchCourse} onChange={(val) => onComboChange('searchCourse', val)} degree={-1} fieldId={""}/>
              </Col>
              <Col md={3}>
                <SchoolClassCombo returnFullItem={true} value={searchSchoolClass} onChange={(val) => onComboChange('searchSchoolClass', val)} />
              </Col>
              <Col md={3}>
                <EduMonthCombo returnFullItem={true} value={searchMonth} onChange={(val) => onComboChange('searchMonth', val)} />
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={{float:'right', margin:'10px', display:'block', direction:"ltr", textAlign:"right"}}>
                  <Button label="جستجو" icon="pi pi-search" onClick={()=>searchExams()} severity="primary" iconPos="right" />
                </div>
                
              </Col>
            </Row>
        </div>
      </div>
      <div className="card" style={{overflow:"scroll", marginTop:"10px"}}>
        {
          loading?
                  <DataTable value={LoadingRows}  className="p-datatable-striped">
                      <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
                      <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
                  </DataTable>
          :
            <>
            <div className='col-12' style={{overflowX:"hidden"}}>
              <Row style={{}}>
                <Col md={2}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right", margin:"10px" }}>             
                    <Button label="افزودن به لیست" icon="pi pi-plus" onClick={()=>addNewItem()} severity="secondary" iconPos="right" />
                  </div>                
                </Col>
              </Row>
              <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" 
              currentPageReportTemplate="{first} تا {last} از {totalRecords}"
              dataKey="id" selection={null}  onSelectionChange={(e) => {setCurrentId(e.value.id)}}>
                      <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                      <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                      {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                      <Column field="testDate" body={(row) => util.SeperateDate(row.testDate)} header={"تاریخ"} sortable className="list-cell-text-align"></Column>
                      <Column field="schoolClass.name" body={(row) => row.schoolClass.name} header={"کلاس"} sortable className="list-cell-text-align"></Column>
                      <Column field="course.name" body={(row) => row.course.name} header={"درس"} sortable className="list-cell-text-align"></Column>
                      <Column field="comment" body={(row) => row.comment} header={"شرح"} sortable className="list-cell-text-align"></Column>
                      <Column field="monthInd" body={(row)=>{return (<>[{row.monthInd}]&nbsp;{row.isFinal?"نهائی":""}</>)}} header={"ماه کارنامه"} sortable className="list-cell-text-align"></Column>
                      <Column body={(row) => setRowActions(row)} exportable={false} style={{ width:"100px" }}></Column>
              </DataTable>
            </div>
            </>
        }           
      </div>
      {
      newFormVisible?
      <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header="ثبت نمرات آزمون جدید" modal className="p-fluid" footer={() => newDialogFooter()} onHide={() => closeNewDialog()}>
        <table style={{marginTop:"10px", width:"100%"}}>
          <tbody>
            <tr>
              <td style={{width:"100px"}}>تاریخ آزمون </td>
            </tr>
            <tr>
              <td style={{width:"140px"}}><FaDate value={date} onChange={(val)=>setNewDate(val)} /></td>
            </tr>
            <tr>
              <td style={{paddingTop:"10px"}}>
                <TeacherSchoolClassCourseCombo schoolClassId={this.state.schoolCalss==null? "":this.state.schoolCalss.id} courseId={this.state.course==null?"" : course.id} onChange={(value)=>{console.log(value); setSchoolclass(value.schoolClass); setCourse(value.course)}} />
              </td>
            </tr>
            <tr>
              <td style={{paddingTop:"10px"}}>
                <FloatLabel>
                  <InputText value={comment} onChange={(e) => { onInputChange(e, "comment") }} id="comment" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                  <label htmlFor="username">شرح</label>
                </FloatLabel>
              </td>
            </tr>
            <tr>
              <td style={{paddingTop:"10px"}}>
                <EduMonthCombo value={month} onChange={(value)=>{setMonth(value)}} />
                  <br/>
                  از کادر فوق برای ثبت در کارنامه ماه تحصیلی استفاده می شود
              </td>
            </tr>
          </tbody>
        </table>

      </Dialog>
      :
      <></>
      }
      {
        editFormVisible?
        <ScoreSave targetType={scoreTargetType} schoolClassDegree={schoolClassDegree} targetId={scoreTargetId} onChange={(targetType, targetId)=>{onContinualTestChanged(targetType, targetId)}} onClose={()=>setEditFormVisible(false)} />
        :
        <></>
      }
    <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
    <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
    </>  
  );
}
